export default __webpack_public_path__ + "static/media/GroupHealthInsurance.9d560aa0.svg";